import reportsConfig from '~/constants/data-reports/cathode'

const priceCathodeData = {
  hero: reportsConfig.hero,
  descriptions: [
    'Our Price Assessments draw on Benchmark’s proprietary databases, tracking every global production facility, capacity expansions, technology developments and industry partnerships to provide clarity to the complex lithium ion battery landscape',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,f_auto/v1719502633/assets/market/cathode/prices/benchmarkminerals_batteries_photo_photorealistic_Hyper-realism__6977377b-088a-48be-a434-cbbbb8e9f61b_bkxstv.png',
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Access to exclusive Cathode data, with company and regional capacity, and supply demand/analytics',
    },
    {
      icon: 'services/icon-report',
      description:
        'Monthly report providing Cathode prices and insights to reveal the direction of the midstream battery sector',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-global',
      description:
        'A global perspective on the evolution of the Cathode industry.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  brochureFile: {
    file_name: 'Benchmark-Cathode-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'cathodePriceAssessmentsMethodologyId',
  },
  indexTab: true,
  requiredFilters: ['categories', 'shippingRoutes', 'priceTypes'],
}
export default priceCathodeData
